import { LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  description?: string;
  trend?: "up" | "down" | "neutral";
  onClick?: () => void;
}

export function StatCard({ title, value, icon: Icon, description, trend, onClick }: StatCardProps) {
  return (
    <Card className={`hover:shadow-md transition-shadow ${onClick ? "cursor-pointer" : ""}`} onClick={onClick}>
      <CardContent className="p-3 sm:p-4">
        <div className="flex items-center justify-between gap-2">
          <div className="min-w-0">
            <p className="text-xs text-muted-foreground truncate">{title}</p>
            <p className="text-base sm:text-xl font-bold mt-0.5">{value}</p>
            {description && (
              <p className={`text-[10px] sm:text-xs mt-0.5 truncate ${trend === "up" ? "text-green-600" : trend === "down" ? "text-destructive" : "text-muted-foreground"}`}>
                {description}
              </p>
            )}
          </div>
          <div className="h-8 w-8 sm:h-10 sm:w-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
            <Icon className="h-4 w-4 sm:h-5 sm:w-5 text-primary" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
